export default "__VITE_ASSET__Dws9WzXZ__"